export default {
  repositories: {},
  foldersStack: {},
  filesStack: {},
  permissionsStack: {},
  subscriptionsStack: {},
  selectedRepositoryId: null,
  selectedFolderId: null,
  selectedElement: {},
  loading: false,
  loadingElements: false,
  loadingTemplates: false,
  approvals: null,
  previousVersions: [],
};
